module.exports = __webpack_public_path__ + "static/media/08_Hinz_webfinal.c23e79e6.jpg";